import { PropsWithChildren } from 'react';
import S from '../SubscriptionPayment.module.scss';
const Title = (props: PropsWithChildren) => <div className={S.section_title} data-sentry-component="Title" data-sentry-source-file="PlanCheckoutSection.tsx">{props.children}</div>;
const SubTitle = (props: PropsWithChildren) => <div className={S.section_sub_title} data-sentry-component="SubTitle" data-sentry-source-file="PlanCheckoutSection.tsx">{props.children}</div>;
const _PlanCheckoutSection = () => <></>;
export const PlanCheckoutSection = Object.assign(_PlanCheckoutSection, {
  SubTitle,
  Title
});